import Pristine from 'pristinejs';
import { putData, getData } from '../../utils/data';

/**
 * Form validation using the PristineJS library.
 * @module directives/form/validatorDirective
 * @see https://github.com/sha256/Pristine
 */

/**
 * Enhances forms with live validation.
 */
export default function validatorDirective() {
      
  /**
   * Set eneabled state of forms.
   * @param {HTMLElement} form - The form to enable.
   * @param {Booealn} enabled - The enabled state to set.
   */
  const setFormEnabled = (form, enabled) => {
    form.querySelectorAll('input, select, textarea').forEach(form => form.readonly = !enabled);
    form.querySelectorAll('button').forEach(form => form.disabled = !enabled);
    form.classList[!enabled ? 'add' : 'remove']('is-posting');
  }

  // Attach validators to forms.
  const forms = document.querySelectorAll('form[data-sw-validator]');
  if (forms.length > 0) forms.forEach(form => {

    // Attach a validator to the form.
    let validator = {

      // Pristine validator
      validator: new Pristine(form, {
        classTo: 'w-full',
        errorTextParent: 'field',
        errorClass: '-pristine-is-invalid',
        successClass: '-pristine-is-valid',
        errorTextClass: 'float-label_errors'
      }, false),

      // Initially not listening for form submits.
      isListening: false,

      // Submit the form.
      submit: function(event = null) {

        console.log('validator submit');

        if (event) event.preventDefault();

        // Submit listener.
        const submitListener = event => this.submit(event);

        // Remove any server error messages.
        form.querySelectorAll('.-served-error').forEach(error => error.remove());
        
        // Check valid.
        const valid = this.validator.validate();
        if (valid) {

          console.log('validator valid');

          // Disable form.
          setFormEnabled(form, false);

          // Enable on load.
          const target = form.target,
          container = target ? document.querySelector(`iframe[name="${target}"]`) : document;
          container.addEventListener('load', _ => setFormEnabled(form, true));

          // Remove submit listener and post it.
          form.removeEventListener('submit', submitListener);
          form.submit();
        } else {

          console.log('validator invalid');

          // reCaptcha is removed on first post, so we need to hook on a submit function.
          if (!this.isListening) form.addEventListener('submit', submitListener);
          this.isListening = true;
        }
      }
    };
    
    putData(form, 'validator', validator);
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/validator.js